import StructureProblemCategory from '@/models/read/StructureProblemCategory';

class StructureProblems {
    constructor({ sections }) {
        this._categories = [];
        sections.forEach((section) => {
            Object.values(section.categories).forEach((category) => {
                if (this._categoryHasSelectedProblem(category)) {
                    this._categories.push(new StructureProblemCategory(category));
                }
            });
        });
    }

    get categories() {
        return this._categories;
    }

    _categoryHasSelectedProblem(category) {
        let selected = false;
        category.types.forEach((type) => {
            type.areas.forEach((area) => {
                area.problems.forEach((problem) => {
                    if (problem.selected === true) {
                        selected = true;
                    }
                });
            });
        });

        return selected;
    }
}

export default StructureProblems;
